import VueShortkey from 'vue-shortkey'

const VueShortkeyPlugin = {
    install(Vue) {
        Vue.use(VueShortkey, { prevent: ['input', 'textarea'] })
    },
}

export default VueShortkeyPlugin
